/* eslint-disable */

import { useState, useEffect, Suspense, useCallback, useRef } from "react";
import {
    Box,
    Tab,
    Tabs,
    Typography,
    Paper,
    Grid,
    IconButton,
    TextField,
    Chip,
    FormControl,
    FormControlLabel,
    Checkbox,
    Button,
    Collapse,
    Autocomplete,
    Divider
} from "@mui/material";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { downloadFile, fetchSearchData } from "../../js/utils/backend";
import CircularProgress from "@mui/material/CircularProgress";
import { t } from "react-i18nify";
import { BasicTooltip } from "./StyledComponents";
import { 
    updateHighlightedRows, 
    updateEntitiesResults, 
    updateDocumentsResults, 
    updateStationsResults, 
    updateZonesResults, 
    updateSamplingsResults, 
    clearSearchResults, 
    updateFilters
} from "../../js/redux/actions/userPref";
import { dateTimeToString, historyPush, showPreview } from "../../js/utils/genericMethods";
import Badge from "@mui/material/Badge";
import OpenLinkIcon from "@mui/icons-material/LaunchOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PreviewIcon from "@mui/icons-material/Preview";
import GroupsIcon from '@mui/icons-material/Groups';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { isDocuments, isPhotoVideo } from "../Views/DocumentsView";
import { DataGridPro, GridActionsCellItem } from "@mui/x-data-grid-pro";
import { ColorButton } from "mui-color";
import DoneIcon from "@mui/icons-material/Done";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import { MenuKebab } from "./MenuKebab";
import WarningOutlinedIcon from "@mui/icons-material/WarningOutlined";
import BiotechIcon from "@mui/icons-material/Biotech";
import PhotoIcon from "@mui/icons-material/Photo";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import ArticleIcon from "@mui/icons-material/Article";
import CategoryIcon from "@mui/icons-material/Category";
import ConstructionIcon from "@mui/icons-material/Construction";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import { KeywordsSelectURL, Select } from "./Custom Inputs/Select";
import { VDateOnlyPicker } from "./Custom Inputs/CustomInputs";
import { useForm, FormProvider } from "react-hook-form";
import { optionsDocumentCategory } from "../../js/constants/selectOptions";
import { mimeTypeCategories } from "../Views/DocumentView/cst_DocumentsView";
import dayjs from "dayjs";
import { updateQuickSearchFilter, updateMaxResultCount } from "../../js/redux/actions/userPref";
import { randomID } from "../../routers/MenuRouter";
import { toastr } from "react-redux-toastr";
import { setShowAdvancedSearchCriterias } from "../../js/redux/actions/userPref";
import { BasicDialog } from "../DataGrid/cst_DataGrid";
import AlertDetailGrid from "../DataGrid/AlertDetailGrid";
import { updateSearchCategoriesImmediate } from "../../js/redux/actions/userPref";


const ensureEntityStatusCriteria = criterias => {
    if (criterias.some(criteria => criteria.value === "EntityStatus")) {
        return criterias;
    }
    return [...criterias, { label: "Entity status", value: "EntityStatus", selected: null, checked: false }];
};

const TabPanel = props => {
    const { children, value, index, ...other } = props;

    return (
        <Box
            sx={{ width: "inherit" }}
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box component="ul" sx={{ py: 3, px: 0 }}>
                    {children}
                </Box>
            )}
        </Box>
    );
};

const QuickSearchResultsTabs = () => {
    const [value, setValue] = useState(0);
    const { searchInput } = useParams();
    const quickSearchFilter = useSelector(
        state => state.userPref.QuickSearchFilter
    );
    const maxResultCountRedux = useSelector(
        state => state.userPref.MaxResultCount
    );

    const maxResultOptions = [
        { label: "5", value: 5 },
        { label: "10", value: 10 }, 
        { label: "20", value: 20 },
        { label: "50", value: 50 },
        { label: "100", value: 100 },
    ];

    const location = useLocation();
    const currentLocation = location.pathname;

    const token = useSelector(state => state.auth.Token);
    const { Reader, GisManager } = useSelector(state => state.auth);
    const currentEntity = useSelector(state => state.userPref.CurrentEntity);

    // Get search results from Redux
    const entitiesResults = useSelector(state => state.userPref.EntitiesResults);
    const documentsResults = useSelector(state => state.userPref.DocumentsResults);
    const stationsResults = useSelector(state => state.userPref.StationsResults);
    const zonesResults = useSelector(state => state.userPref.ZonesResults);
    const samplingsResults = useSelector(state => state.userPref.SamplingsResults);

    // Keep last known results snapshot without re-triggering effects on each update
    const resultsSnapshotRef = useRef({
        entitiesResults,
        documentsResults,
        stationsResults,
        zonesResults,
        samplingsResults,
    });

    useEffect(() => {
        resultsSnapshotRef.current = {
            entitiesResults,
            documentsResults,
            stationsResults,
            zonesResults,
            samplingsResults,
        };
    }, [entitiesResults, documentsResults, stationsResults, zonesResults, samplingsResults]);

    const showFilters = useSelector(state => state.userPref.ShowAdvancedSearchCriterias);

    const dispatch = useDispatch();
    const history = useHistory();

    const [localCategories, setLocalCategories] = useState(
        quickSearchFilter?.SearchCategories ? JSON.parse(JSON.stringify(quickSearchFilter.SearchCategories)) : []
    );

    const entitiesSearchEnabled = localCategories.some(category => category.value === "Entities" && category.checked);

    useEffect(() => {
        setLocalCategories(
            quickSearchFilter?.SearchCategories ? JSON.parse(JSON.stringify(quickSearchFilter.SearchCategories)) : []
        );
    }, [quickSearchFilter?.SearchCategories]);

    const CORRESPONDANCE_STATES = {
        Entities: entitiesResults,
        Documents: documentsResults,
        Stations: stationsResults,
        Zones: zonesResults,
        Samplings: samplingsResults
    };

    const [loadResults, setLoadResults] = useState(false);
    const [isFiltering, setIsFiltering] = useState(false);

    const [filterCriterias, setFilterCriterias] = useState(
        quickSearchFilter?.SearchCriterias.length > 0 ? ensureEntityStatusCriteria(quickSearchFilter.SearchCriterias) : [
            { label: "Match case", value: "MatchCase", checked: false },
            { label: "Match whole words", value: "MatchWholeWords", checked: false },
            { label: "Match special characters", value: "MatchAccented", checked: false },
            { label: "Sound like", value: "SoundLike", checked: false },
            { label: "Keywords Only", value: "KeywordsOnly", selected: [], checked: false },
            { label: "Date", value: "Date", startDate: null, endDate: null, checked: false },
            { label: "File Type", value: "FileType", selected: [], checked: false },
            { label: "State", value: "State", selected: [], checked: false },
            { label: "Category", value: "Category", selected: [], checked: false },
            { label: "Entity status", value: "EntityStatus", selected: null, checked: false }
        ]
    );

    useEffect(() => {
        if(filterCriterias.length > 0){
            setFilterCriterias(filterCriterias);
        }
        else if(quickSearchFilter?.SearchCriterias.length > 0) {
            setFilterCriterias(ensureEntityStatusCriteria(quickSearchFilter.SearchCriterias));
        }
        else{
            setFilterCriterias([
                { label: "Match case", value: "MatchCase", checked: false },
                { label: "Match whole words", value: "MatchWholeWords", checked: false },
                { label: "Match special characters", value: "MatchAccented", checked: false },
                { label: "Sound like", value: "SoundLike", checked: false },
                { label: "Keywords Only", value: "KeywordsOnly", selected: [], checked: false },
                { label: "Date", value: "Date", startDate: null, endDate: null, checked: false },
                { label: "File Type", value: "FileType", selected: [], checked: false },
                { label: "State", value: "State", selected: [], checked: false },
                { label: "Category", value: "Category", selected: [], checked: false },
                { label: "Entity status", value: "EntityStatus", selected: null, checked: false }
            ]);
        }
    }, [quickSearchFilter?.SearchCriterias]);
    
    const [filterStartDate, setFilterStartDate] = useState(null);
    const [filterEndDate, setFilterEndDate] = useState(null);
    const [selectedFilterFileType, setSelectedFilterFileType] = useState(null);
    const [selectedFilterState, setSelectedFilterState] = useState(null);
    const [selectedFilterCategory, setSelectedFilterCategory] = useState(null);
    const [selectedFilterEntityStatus, setSelectedFilterEntityStatus] = useState(null);
    
    const filterMethods = useForm();

    const fileStates = [
        { label: "Draft", value: "Draft" },
        { label: "Under Validation", value: "UnderValidation" },
        { label: "Reviewed", value: "Reviewed" },
        { label: "Final", value: "Final" }
    ];

    const entityStatuses = [
        { value: "ProjectPhase", label: t("common.ProjectPhase") },
        { value: "Operated", label: t("common.Operated") },
        { value: "CeaseOfActivity", label: t("common.CeaseOfActivity") },
        { value: "Deactivated", label: t("common.Deactivated") }
    ];

    const [expandedBranches, setExpandedBranches] = useState([]);

    const fileTypeOptions = [
        ...mimeTypeCategories.PhotoVideo,
        ...mimeTypeCategories.Documents
    ].filter((item, index, self) =>
        index === self.findIndex(t => t.Name === item.Name)
    )
    .map(item => ({
        value: item.Extension,
        label: item.Name + (item.Extension ? ` (${item.Extension})` : "")
    }));

    const categoryOptions = optionsDocumentCategory.map(e => ({
        ...e,
        label: t(`${e.label}`)
    }));

    const handleToggleFilters = () => {
        dispatch(setShowAdvancedSearchCriterias(!showFilters));
    };

    const updateFilterCriterias = (e) => {
        const { name, checked } = e.target;
        const allowed = ["FileType", "Category", "State", "Date", "KeywordsOnly"];
        
        // Check if Documents category is checked in the search filter
        const documentsCategory = quickSearchFilter?.SearchCategories?.find(cat => cat.label === "Documents");
        const documentsChecked = documentsCategory?.checked || false;
        const entitiesChecked = entitiesSearchEnabled;
        
        let updated = filterCriterias.map(item => {
            if (item.value === "EntityStatus" && !entitiesChecked) {
                return { ...item, disabled: true, checked: false };
            }
            // Prevent enabling document-related criteria if Documents category is unchecked
            if (!documentsChecked && ["FileType", "Category", "State", "KeywordsOnly", "Date"].includes(item.value)) {
                return {
                    ...item,
                    disabled: true,
                    checked: false
                };
            }
            
            if (name === "KeywordsOnly") {
                if (checked) {
                    if (!documentsChecked) {
                        return item;
                    }
                    
                    if (item.value === "KeywordsOnly") {
                        return {
                            ...item,
                            checked: true,
                            disabled: false
                        }
                    } else if (allowed.includes(item.value)) {
                        return {
                            ...item,
                            disabled: false
                        };
                    } else {
                        return {
                            ...item,
                            checked: false,
                            disabled: true
                        };
                    }
                } else {
                    if (item.value === "KeywordsOnly") {
                        setNoKeywordsSelected("");
                        return {
                            ...item,
                            checked: false,
                            selected: []
                        };
                    }
                    return {
                        ...item,
                        disabled: !documentsChecked ? true : false
                    };
                }
            }
            
            // For document-related criteria, check if Documents category is enabled
            if (["FileType", "Category", "State"].includes(name) && checked && !documentsChecked) {
                return item; // Don't allow checking if Documents is unchecked
            }
            
            if (name === "Date" && !checked) {
                setFilterStartDate(null);
                setFilterEndDate(null);
                setNoDateSelected("");
                filterMethods.setValue("filterStartDate", null);
                filterMethods.setValue("filterEndDate", null);
                if (item.label === "Date") {
                    return {
                        ...item,
                        checked: false,
                        startDate: null,
                        endDate: null
                    };
                }
            }
            if (name === "FileType" && !checked) {
                setSelectedFilterFileType(null);
                setNoFileTypeSelected("");
                filterMethods.setValue("filterFileType", null);
                if (item.value === "FileType") {
                    return {
                        ...item,
                        checked: false,
                        selected: null
                    };
                }
            }
            if (name === "Category" && !checked) {
                setSelectedFilterCategory(null);
                setNoCategorySelected("");
                filterMethods.setValue("filterCategory", null);
                if (item.value === "Category") {
                    return {
                        ...item,
                        checked: false,
                        selected: null
                    };
                }
            }
            if (name === "State" && !checked) {
                setSelectedFilterState(null);
                setNoStateSelected("");
                filterMethods.setValue("filterState", null);
                if (item.value === "State") {
                    return {
                        ...item,
                        checked: false,
                        selected: null
                    };
                }
            }

            if (name === "EntityStatus" && !checked && item.value === "EntityStatus") {
                setSelectedFilterEntityStatus(null);
                setNoEntityStatusSelected("");
                return { ...item, checked: false, selected: null };
            }
            
            if (!item.disabled && item.value === name) {
                return { ...item, checked };
            }
            return item;
        });

        setFilterCriterias(updated);
        
        dispatch(updateQuickSearchFilter({
            ...quickSearchFilter,
            SearchCriterias: updated
        }));

        dispatch(updateFilters());
    };

    const handleFilterKeywordsChange = (selectedKeywords) => {
        const uniqueKeywords = [...new Set(selectedKeywords)];
        
        const updated = filterCriterias.map(item =>
            item.value === "KeywordsOnly"
                ? { ...item, selected: uniqueKeywords }
                : item
        );
        setFilterCriterias(updated);

        dispatch(updateQuickSearchFilter({
            ...quickSearchFilter,
            SearchCriterias: updated
        }));

        if (uniqueKeywords && uniqueKeywords.length > 0) {
            setNoKeywordsSelected("");
        }
    };

    const handleFilterStartDateChange = (date) => {
        setFilterStartDate(date);
        const updated = filterCriterias.map(item =>
            item.value === "Date"
                ? { ...item, startDate: date }
                : item
        );
        setFilterCriterias(updated);

        dispatch(updateQuickSearchFilter({
            ...quickSearchFilter,
            SearchCriterias: updated
        }));

        if (date) {
            setNoDateSelected("");
        }
    };

    const handleFilterEndDateChange = (date) => {
        setFilterEndDate(date);
        const updated = filterCriterias.map(item =>
            item.value === "Date"
                ? { ...item, endDate: date }
                : item
        );
        setFilterCriterias(updated);

        dispatch(updateQuickSearchFilter({
            ...quickSearchFilter,
            SearchCriterias: updated
        }));

        if (date) {
            setNoDateSelected("");
        }
    };

    // const [maxResultCount, setMaxResultCount] = useState(
    //     maxResultCountRedux
    //         ? maxResultCountRedux
    //         : maxResultOptions[4]
    // );

    const [maxResultCount, setMaxResultCount] = useState(
        typeof maxResultCountRedux === "number" ? maxResultCountRedux : 100
    );

    useEffect(() => {
        if (typeof maxResultCountRedux === "number") {
            setMaxResultCount(maxResultCountRedux);
        }
    }, [maxResultCountRedux]);

    // Watch for form changes
    useEffect(() => {
        const subscription = filterMethods.watch((values) => {
            setFilterCriterias(prev =>
                prev.map(item =>
                    item.value === "Category"
                        ? { ...item, selected: values.filterCategory }
                        : item.value === "FileType"
                        ? { ...item, selected: values.filterFileType }
                        : item.value === "State"
                        ? { ...item, selected: values.filterState }
                        : item
                )
            );
        });
        return () => subscription.unsubscribe && subscription.unsubscribe();
    }, [filterMethods]);

    useEffect(() => {
        const subscription = filterMethods.watch((values) => {
            if (values.filterFileType) {
                setSelectedFilterFileType(values.filterFileType);
            }
            if (values.filterState) {
                setSelectedFilterState(values.filterState);
            }
            if (values.filterCategory) {
                setSelectedFilterCategory(values.filterCategory);
            }
        });
        return () => subscription.unsubscribe && subscription.unsubscribe();
    }, [filterMethods]);


    useEffect(() => {
        if (quickSearchFilter?.SearchCriterias && filterCriterias.length === 0) {
            setFilterCriterias(quickSearchFilter.SearchCriterias);
            
            const dateFilter = quickSearchFilter.SearchCriterias.find(c => c.value === "Date");
            const fileTypeFilter = quickSearchFilter.SearchCriterias.find(c => c.value === "FileType");
            const stateFilter = quickSearchFilter.SearchCriterias.find(c => c.value === "State");
            const categoryFilter = quickSearchFilter.SearchCriterias.find(c => c.value === "Category");
            const entityStatusFilter = quickSearchFilter.SearchCriterias.find(c => c.value === "EntityStatus");
            
            let startDateFormatted = null;
            let endDateFormatted = null;
            
            if (dateFilter?.startDate) {
                const startDateObj = dayjs(dateFilter.startDate);
                startDateFormatted = startDateObj.format("DD/MM/YYYY");
            }
            
            if (dateFilter?.endDate) {
                const endDateObj = dayjs(dateFilter.endDate);
                endDateFormatted = endDateObj.format("DD/MM/YYYY");
            }
            
            setFilterStartDate(startDateFormatted);
            setFilterEndDate(endDateFormatted);
            setSelectedFilterFileType(fileTypeFilter?.selected || null);
            setSelectedFilterState(stateFilter?.selected || null);
            setSelectedFilterCategory(categoryFilter?.selected || null);
            setSelectedFilterEntityStatus(entityStatusFilter?.selected || null);
            filterMethods.reset({
                filterFileType: fileTypeFilter?.selected || null,
                filterState: stateFilter?.selected || null,
                filterCategory: categoryFilter?.selected || null,
                filterStartDate: startDateFormatted,
                filterEndDate: endDateFormatted
            });
        }
        else{            
            const dateFilter = filterCriterias.find(c => c.value === "Date");
            const fileTypeFilter = filterCriterias.find(c => c.value === "FileType");
            const stateFilter = filterCriterias.find(c => c.value === "State");
            const categoryFilter = filterCriterias.find(c => c.value === "Category");
            const entityStatusFilter = filterCriterias.find(c => c.value === "EntityStatus");
            
            let startDateFormatted = null;
            let endDateFormatted = null;
            
            if (dateFilter?.startDate) {
                const startDateObj = dayjs(dateFilter.startDate);
                startDateFormatted = startDateObj.format("DD/MM/YYYY");
            }
            
            if (dateFilter?.endDate) {
                const endDateObj = dayjs(dateFilter.endDate);
                endDateFormatted = endDateObj.format("DD/MM/YYYY");
            }
            
            setFilterStartDate(startDateFormatted);
            setFilterEndDate(endDateFormatted);
            setSelectedFilterFileType(fileTypeFilter?.selected || null);
            setSelectedFilterState(stateFilter?.selected || null);
            setSelectedFilterCategory(categoryFilter?.selected || null);
            setSelectedFilterEntityStatus(entityStatusFilter?.selected || null);
            filterMethods.reset({
                filterFileType: fileTypeFilter?.selected || null,
                filterState: stateFilter?.selected || null,
                filterCategory: categoryFilter?.selected || null,
                filterStartDate: startDateFormatted,
                filterEndDate: endDateFormatted
            });
        }
    }, [quickSearchFilter?.SearchCriterias, filterMethods]);

    useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed && searchInput) {
            // Always set loadResults to true when searchInput or location changes
            // This could be from a new search or navigation
            setLoadResults(true);
        }
        return () => (isSubscribed = false);
    }, [searchInput, location]);

    useEffect(() => {
        let isSubscribed = true;
        /** We'll fetch results for each result type in the same time, and populate each tab with the number of results */
        const fetchingSearchResults = async () => {
            let pageSize = maxResultCount;
            var entitiesIDs = [];
            var matchCase = quickSearchFilter.SearchCriterias.filter(s => s.value === "MatchCase");
            var matchCaseChecked = matchCase.length > 0 ? matchCase[0].checked : false;
            var matchWholeWords = quickSearchFilter.SearchCriterias.filter(s => s.value === "MatchWholeWords");
            var matchWholeWordsChecked = matchWholeWords.length > 0 ? matchWholeWords[0].checked : false;
            var matchAccented = quickSearchFilter.SearchCriterias.filter(s => s.value === "MatchAccented");
            var matchAccentedChecked = matchAccented.length > 0 ? matchAccented[0].checked : false;
            var soundLike = quickSearchFilter.SearchCriterias.filter(s => s.value === "SoundLike");
            var soundLikeChecked = soundLike.length > 0 ? soundLike[0].checked : false;
            var keywordsOnly = quickSearchFilter.SearchCriterias.filter(s => s.value === "KeywordsOnly");
            var keywordsOnlyChecked = keywordsOnly.length > 0 ? keywordsOnly[0].checked : false;
            var date = quickSearchFilter.SearchCriterias.filter(s => s.value === "Date");
            var dateChecked = date.length > 0 ? date[0].checked : false;
            var fileType = quickSearchFilter.SearchCriterias.filter(s => s.value === "FileType");
            var fileTypeChecked = fileType.length > 0 ? fileType[0].checked : false;
            var state = quickSearchFilter.SearchCriterias.filter(s => s.value === "State");
            var stateChecked = state.length > 0 ? state[0].checked : false;
            var category = quickSearchFilter.SearchCriterias.filter(s => s.value === "Category");
            var categoryChecked = category.length > 0 ? category[0].checked : false;
            var entityStatus = quickSearchFilter.SearchCriterias.find(s => s.value === "EntityStatus");
            var entityStatusValue = entityStatus?.checked ? entityStatus.selected?.value : null;

            const snap = resultsSnapshotRef.current;

            // Build a queue of fetches only for checked categories that need it
            const queue = [];

            for (const item of (quickSearchFilter.SearchCategories || [])) {
                if (!item.checked) {
                    // Clear results for unchecked categories
                    switch (item.value) {
                        case "Entities": dispatch(updateEntitiesResults(undefined)); break;
                        case "Documents": dispatch(updateDocumentsResults(undefined)); break;
                        case "Zones": dispatch(updateZonesResults(undefined)); break;
                        case "Stations": dispatch(updateStationsResults(undefined)); break;
                        case "Samplings": dispatch(updateSamplingsResults(undefined)); break;
                        default: break;
                    }
                    continue;
                }

                const needsFetch = (value) => {
                    if (isFiltering) return true;
                    switch (value) {
                        case "Entities": return snap.entitiesResults === undefined;
                        case "Documents": return snap.documentsResults === undefined;
                        case "Stations": return snap.stationsResults === undefined;
                        case "Zones": return snap.zonesResults === undefined;
                        case "Samplings": return snap.samplingsResults === undefined;
                        default: return false;
                    }
                };

                if (!needsFetch(item.value)) continue;

                // Mark the category as "loading" (null) so tab spinners are per-category
                switch (item.value) {
                    case "Entities": dispatch(updateEntitiesResults(null)); break;
                    case "Documents": dispatch(updateDocumentsResults(null)); break;
                    case "Zones": dispatch(updateZonesResults(null)); break;
                    case "Stations": dispatch(updateStationsResults(null)); break;
                    case "Samplings": dispatch(updateSamplingsResults(null)); break;
                    default: break;
                }

                queue.push(async () => {
                    switch (item.value) {
                        case "Entities": {
                            if (item.submenu && item.submenu.length > 0) {
                                if (item.submenu[0].Countries) {
                                    item.submenu.forEach(branch => {
                                        for (var j = 0; j < branch.Countries.length; j++) {
                                            branch.Countries[j].OTEntities.forEach(obj => {
                                                if (obj.Checked) entitiesIDs.push(obj.Value);
                                            });
                                        }
                                    });
                                } else {
                                    item.submenu.forEach(obj => {
                                        if (obj.checked) entitiesIDs.push(obj.value);
                                    });
                                }
                            }
                            const entitiesFetched = await fetchSearchData(
                                `QuickSearch/Entities`,
                                token,
                                "List",
                                `Keywords=${searchInput}&MatchCase=${matchCaseChecked}&MatchWholeWords=${matchWholeWordsChecked}&MatchAccented=${matchAccentedChecked}&SoundLike=${soundLikeChecked}&EntityStatus=${encodeURIComponent(entityStatusValue || "")}&PageSize=${pageSize}`,
                                entitiesIDs
                            );
                            dispatch(updateEntitiesResults(entitiesFetched.data));
                            break;
                        }
                        case "Documents": {
                            const onlyInKeywords = keywordsOnlyChecked;
                            const browserLang = navigator.language || navigator.userLanguage;
                            const documentsFetched = await fetchSearchData(
                                `QuickSearch/Documents`,
                                token,
                                "List",
                                `Keywords=${searchInput}&PageSize=${pageSize}&MatchCase=${matchCaseChecked}&MatchWholeWords=${matchWholeWordsChecked}&MatchAccented=${matchAccentedChecked}&SoundLike=${soundLikeChecked}&Date=${dateChecked}&FileType=${fileTypeChecked}&State=${stateChecked}&Category=${categoryChecked}&OnlyInKeywords=${onlyInKeywords}&BrowserLang=${browserLang}`,
                                entitiesIDs
                            );
                            dispatch(updateDocumentsResults(documentsFetched.data));
                            break;
                        }
                        case "Zones": {
                            const zonesFetched = await fetchSearchData(
                                `QuickSearch/Zones`,
                                token,
                                "List",
                                `Keywords=${searchInput}&MatchCase=${matchCaseChecked}&MatchWholeWords=${matchWholeWordsChecked}&MatchAccented=${matchAccentedChecked}&SoundLike=${soundLikeChecked}&PageSize=${pageSize}`,
                                entitiesIDs
                            );
                            dispatch(updateZonesResults(zonesFetched.data));
                            break;
                        }
                        case "Stations": {
                            const stationsFetched = await fetchSearchData(
                                `QuickSearch/Stations`,
                                token,
                                "List",
                                `Keywords=${searchInput}&MatchCase=${matchCaseChecked}&MatchWholeWords=${matchWholeWordsChecked}&MatchAccented=${matchAccentedChecked}&SoundLike=${soundLikeChecked}&PageSize=${pageSize}`,
                                entitiesIDs
                            );
                            dispatch(updateStationsResults(stationsFetched.data));
                            break;
                        }
                        case "Samplings": {
                            const samplingsFetched = await fetchSearchData(
                                `QuickSearch/Samplings`,
                                token,
                                "List",
                                `Keywords=${searchInput}&MatchCase=${matchCaseChecked}&MatchWholeWords=${matchWholeWordsChecked}&MatchAccented=${matchAccentedChecked}&SoundLike=${soundLikeChecked}&PageSize=${pageSize}`,
                                entitiesIDs
                            );
                            dispatch(updateSamplingsResults(samplingsFetched.data));
                            break;
                        }
                        default:
                            break;
                    }
                });
            }

            // Nothing to fetch: stop global loading immediately
            if (queue.length === 0) {
                if (isSubscribed) {
                    setLoadResults(false);
                    setIsFiltering(false);
                }
                return;
            }

            // Execute sequentially
            for (const run of queue) {
                if (!isSubscribed) break;
                await run();
            }

            if (isSubscribed) {
                setLoadResults(false);
                setIsFiltering(false);
            }
        };

        if (isSubscribed && loadResults && quickSearchFilter) {
            const hasRelevantCachedData = quickSearchFilter.SearchCategories?.every(category => {
                if (!category.checked) return true;
                const snap = resultsSnapshotRef.current;
                switch (category.value) {
                    case "Entities": return snap.entitiesResults !== undefined;
                    case "Documents": return snap.documentsResults !== undefined;
                    case "Stations": return snap.stationsResults !== undefined;
                    case "Zones": return snap.zonesResults !== undefined;
                    case "Samplings": return snap.samplingsResults !== undefined;
                    default: return true;
                }
            });

            if (isFiltering || !hasRelevantCachedData) {
                (async () => { await fetchingSearchResults(); })();
            } else {
                setLoadResults(false);
            }
        }
        return () => (isSubscribed = false);
    }, [
        quickSearchFilter,
        quickSearchFilter.SearchCategories,
        searchInput,
        token,
        loadResults,
        isFiltering,
        maxResultCount,
        dispatch,
    ]);

    useEffect(() => {
        const documentsCategory = quickSearchFilter?.SearchCategories?.find(cat => cat.label === "Documents");
        const documentsChecked = documentsCategory?.checked || false;
        const entitiesChecked = entitiesSearchEnabled;
        
        if (!documentsChecked) {
            // Disable and uncheck document-related criteria when Documents is unchecked
            const updatedCriterias = filterCriterias.map(criteria => {
                if (criteria.value === "EntityStatus") {
                    return {
                        ...criteria,
                        checked: entitiesChecked ? criteria.checked : false,
                        selected: entitiesChecked ? criteria.selected : null,
                        disabled: !entitiesChecked
                    };
                }
                if (["FileType", "Category", "State", "KeywordsOnly", "Date"].includes(criteria.value)) {
                    const resetCriteria = {
                        ...criteria,
                        checked: false,
                        disabled: true
                    };

                    if (criteria.value === "KeywordsOnly") resetCriteria.selected = [];
                    if (criteria.value === "FileType") resetCriteria.selected = null;
                    if (criteria.value === "Category") resetCriteria.selected = null;
                    if (criteria.value === "State") resetCriteria.selected = null;
                    if (criteria.value === "Date") resetCriteria.startDate = null;
                    if (criteria.value === "Date") resetCriteria.endDate = null;
                    return resetCriteria;
                }
                return criteria;
            });

            setFilterCriterias(updatedCriterias);
            
            setSelectedFilterFileType(null);
            setSelectedFilterState(null);
            setSelectedFilterCategory(null);
            if (!entitiesChecked) {
                setSelectedFilterEntityStatus(null);
                setNoEntityStatusSelected("");
            }
            filterMethods.reset({
                filterFileType: null,
                filterState: null,
                filterCategory: null,
                filterStartDate: filterStartDate,
                filterEndDate: filterEndDate
            });
        } else {
            // Enable document-related criteria when Documents is checked
            const updatedCriterias = filterCriterias.map(criteria => {
                if (criteria.value === "EntityStatus") {
                    return {
                        ...criteria,
                        checked: entitiesChecked ? criteria.checked : false,
                        selected: entitiesChecked ? criteria.selected : null,
                        disabled: !entitiesChecked
                    };
                }
                if (["FileType", "Category", "State", "KeywordsOnly", "Date"].includes(criteria.value)) {
                    return {
                        ...criteria,
                        disabled: false
                    };
                }
                return criteria;
            });
            
            setFilterCriterias(updatedCriterias);
            if (!entitiesChecked) {
                setSelectedFilterEntityStatus(null);
                setNoEntityStatusSelected("");
            }
        }
    }, [quickSearchFilter?.SearchCategories, entitiesSearchEnabled]);

    const handleChangeCurrentTab = (_event, newValue) => {
        setValue(newValue);
    };

    /** For each result, we display a redirection link, regarding the route/data grid where the element can be found (cf. MenuRouter) */
    const linkRedirection = (item, type) => {
        switch (type) {
            case "Entities":
                return entitiesRoutes(item);
            case "Documents":
                return documentsRoutes(item);
            case "Stations":
                return stationsRoutes(item);
            case "Zones":
                return zonesRoutes(item);
            case "Samplings":
                return samplingsRoutes(item);
            default:
                return null;
        }
    };
    function entitiesRoutes(item) {
        return `/entity-page/${item.ObjectID}`;
    }
    /** A document can be a node, but also attached to a Station or a Sampling (element), and be a photoVideo type (fileType). Basically, we rebuild the defined route in MenuRouter.js  */
    function documentsRoutes(item) {
        if (item.StationType || item.SamplingType) {
            let fileType = item.IsPhotoVideo ? isPhotoVideo : isDocuments;
            let element = item.StationType ?? item.SamplingType;
            let elementID =
                item.StationID ?? item.SamplingID ?? item.ContainingNode;
            return `/${fileType}/${element}/${elementID}/true/${item.OTEntityID}`;
        } else {
            return `/documentNode/${item.ContainingNode}/true`;
        }
    }
    function stationsRoutes(item) {
        return `/datagrid/${item.StationType}/${item.ContainingNode}/root/OTEntityID/${item.OTEntityID}`;
    }
    /** A zone is attached to an entity, but can also be related ot a study. */
    function zonesRoutes(item) {
        let relatedElement = item.StudyID ? "study" : "entity";
        return `/datagrid/zone/${relatedElement}/${item.ContainingNode}`;
    }

    function samplingsRoutes(item) {
        return `/datagrid/${item.SampleType}Sampling/${item.ContainingNode}/root/OTEntityID/${item.OTEntityID}`;
    }

    const entitiesSpecificActionsColumns = (params) => [
        <>
            <GridActionsCellItem
                label={t("common.RedirectTo")}
                icon={
                    <BasicTooltip title={`${t("common.RedirectTo")}`}>
                        <OpenLinkIcon />
                    </BasicTooltip>
                }
                onClick={() => {
                    const link = linkRedirection(
                        params.row,
                        "Entities"
                    );
                    historyPush(history, `${link}`, { withBackButton: true });
                }}
            />
        </>
    ];

    const documentsSpecificActionsColumns = (params) => [
        <>
            {showPreview(params.row.Filename) && (
                <GridActionsCellItem
                    label={t("common.PreviewFile")}
                    icon={
                        <BasicTooltip
                            title={`${t("common.PreviewFile")}`}
                        >
                            <PreviewIcon />
                        </BasicTooltip>
                    }
                    onClick={() => {
                        downloadFile(
                            token,
                            "preview",
                            `/${params.row.MediaID}/${params.row.OTEntityID}`
                        );
                    }}
                />
            )}
            <GridActionsCellItem
                label="Download file"
                icon={
                    <BasicTooltip title={`${t("common.Download")}`}>
                        <DownloadOutlinedIcon />
                    </BasicTooltip>
                }
                onClick={() => {
                    dispatch(
                        updateHighlightedRows({
                            CurrentLocation: currentLocation,
                            VisitedRowID: params.row.ObjectID,
                        })
                    );
                    downloadFile(
                        token,
                        "download",
                        `/${params.row.MediaID}/${params.row.OTEntityID}`
                    );
                }}
            />
            {params.row.Category === "Public" && !Reader && !GisManager &&
                <GridActionsCellItem
                    label={t("common.ManageSharePermissions")}
                    icon={
                        <BasicTooltip title={`${t("common.ManageSharePermissions")}`}>
                            <GroupsIcon />
                        </BasicTooltip>
                    }
                    onClick={() => {
                        historyPush(history, `/sharesList/${params.row.ObjectID}`);
                    }}
                />
            }
            <GridActionsCellItem
                label={t("common.RedirectTo")}
                icon={
                    <BasicTooltip title={`${t("common.RedirectTo")}`}>
                        <OpenLinkIcon />
                    </BasicTooltip>
                }
                onClick={() => {
                    const link = linkRedirection(
                        params.row,
                        "Documents"
                    );
                    historyPush(history, `${link}/${encodeURIComponent(params.row.Filename)}`, { withBackButton: true });
                }}
            />
        </>
    ];

    const entitiesActionsColumn = [
        {
            field: "actions",
            headerName: t("common.Actions"),
            type: "actions",
            width: 200,
            cellClassName: "actions",
            sortable: false,
            getActions: params => [ ...entitiesSpecificActionsColumns(params) ],
        },
    ];

    const defaultActionsColumn = [
        {
            field: "actions",
            headerName: t("common.Actions"),
            type: "actions",
            width: 200,
            cellClassName: "actions",
            sortable: false,
            getActions: params => [ ...documentsSpecificActionsColumns(params) ]
        },
    ];

    const stationsActionsColumn = [
        {
            field: "actions",
            headerName: t("common.Actions"),
            type: "actions",
            width: 200,
            cellClassName: "actions",
            sortable: false,
            getActions: params => [
                <MenuKebab disabled={false}>
                    {menuKebab(params, false, false, "stations")}
                </MenuKebab>,
                <GridActionsCellItem
                    label={t("common.RedirectTo")}
                    icon={
                        <BasicTooltip title={`${t("common.RedirectTo")}`}>
                            <OpenLinkIcon />
                        </BasicTooltip>
                    }
                    onClick={() => {
                        const link = linkRedirection(params.row, "Stations");
                        historyPush(history, `${link}/${params.row.Name}`, { withBackButton: true });
                    }}
                />
            ],
        },
    ];

    const samplingsActionsColumn = [
        {
            field: "actions",
            headerName: t("common.Actions"),
            type: "actions",
            width: 200,
            cellClassName: "actions",
            sortable: false,
            getActions: params => [
                <MenuKebab disabled={false}>
                    {menuKebab(params, false, false, "samplings")}
                </MenuKebab>
            ],
        },
    ];

    const menuKebab = (params, editing = false, isLocalLoading = false, gridType = "") => {
        const stationsOptions = [
            {
                "LinkedGrid": "Documents",
                "ToolTip": "Documents",
                "MUIIconName": "Article",
                "Order": 1,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "PhotoVideo",
                "ToolTip": "Photos & Videos",
                "MUIIconName": "Photo",
                "Order": 2,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "StationSGWLithology",
                "ToolTip": "Lithology",
                "MUIIconName": "Category",
                "Order": 100,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "StationSGWWellConstruction",
                "ToolTip": "Well construction",
                "MUIIconName": "Construction",
                "Order": 102,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "StationSGWWellConstructionDetail",
                "ToolTip": "Well construction detail",
                "MUIIconName": "SquareFoot",
                "Order": 103,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "InSituUndergroundMeasurementObservation",
                "ToolTip": "In situ underground measurement observation",
                "MUIIconName": "SquareFoot",
                "Order": 104,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": "StationID",
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "BiologicalSampling",
                "ToolTip": "Biological samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 105,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "SoilAndSoilVapourSampling",
                "ToolTip": "Soil and soil vapour samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 106,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "GroundwaterSampling",
                "ToolTip": "Groundwater samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 107,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "SedimentSampling",
                "ToolTip": "Sediment samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 108,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "WaterSampling",
                "ToolTip": "Water samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 109,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "AirSampling",
                "ToolTip": "Air samplings",
                "MUIIconName": "VaccinesIcon",
                "Order": 110,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": false
            },
            {
                "LinkedGrid": "InSituAirNoiseBiodiversityMeasurement",
                "ToolTip": "In Situ Air, Noise and Biodiversity Measurement",
                "MUIIconName": "SquareFoot",
                "Order": 4,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "InSituWaterSedimentObservation",
                "ToolTip": "In Situ Water & Sediment Observation",
                "MUIIconName": "SquareFoot",
                "Order": 5,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            }
        ];

        const samplingsOptions = [
            {
                "LinkedGrid": "LaboResult",
                "ToolTip": "Labo results",
                "MUIIconName": "Biotech",
                "Order": 1,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": "SubSamplingID",
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "PhotoVideo",
                "ToolTip": "Photos & Videos",
                "MUIIconName": "Photo",
                "Order": 2,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "InSituUndergroundMeasurementObservation",
                "ToolTip": "In situ underground measurement observation",
                "MUIIconName": "SquareFoot",
                "Order": 3,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "InSituAirNoiseBiodiversityMeasurement",
                "ToolTip": "In Situ Air, Noise and Biodiversity Measurement",
                "MUIIconName": "SquareFoot",
                "Order": 4,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            },
            {
                "LinkedGrid": "InSituWaterSedimentObservation",
                "ToolTip": "In Situ Water & Sediment Observation",
                "MUIIconName": "SquareFoot",
                "Order": 5,
                "EnabledForStations": null,
                "SpecificParentFieldForChild": null,
                "isChildGenericGridType": true
            }
        ];

        const getIconComponent = (iconName) => {
            switch (iconName) {
                case "Biotech":
                    return <BiotechIcon />;
                case "Photo":
                    return <PhotoIcon />;
                case "SquareFoot":
                    return <SquareFootIcon />;
                case "Article":
                    return <ArticleIcon />;
                case "Category":
                    return <CategoryIcon />;
                case "Construction":
                    return <ConstructionIcon />;
                case "VaccinesIcon":
                    return <VaccinesIcon />;
                default:
                    return <OpenLinkIcon />;
            }
        };

        switch (gridType) {
            case "stations":
                let filteredStationsOptions = stationsOptions;
        
                if (params.row.StationType === "StationAir") {
                    filteredStationsOptions = stationsOptions.filter((option, index) => 
                        [0, 1, 12, 11].includes(index)
                    );
                }
                else if (params.row.StationType === "StationNoise") {
                    filteredStationsOptions = stationsOptions.filter((option, index) => 
                        [0, 1, 12].includes(index)
                    );
                }
                else if (params.row.StationType === "StationSedimentWater") {
                    filteredStationsOptions = stationsOptions.filter((option, index) => 
                        [0, 1, 13, 6, 9, 10].includes(index)
                    );
                }
                else if (params.row.StationType === "StationBiodiversity") {
                    filteredStationsOptions = stationsOptions.filter((option, index) => 
                        [0, 1, 12, 6].includes(index)
                    );
                }
                else if (params.row.StationType === "StationSoilGroundwater") {
                    filteredStationsOptions = stationsOptions.filter((option, index) => 
                        [0, 1, 2, 3, 4, 5, 6, 7, 8].includes(index)
                    );
                }
                
                return filteredStationsOptions
                    .sort((a, b) => a.Order - b.Order)
                    .map((option, index) => (
                        <Box
                            sx={{ display:"flex", cursor:"pointer", alignItems: "center", "&:hover": { backgroundColor: "action.hover" } }}
                            key={index}
                            onClick={() => {
                                let url = "";
                                if(option.LinkedGrid === "InSituUndergroundMeasurementObservation" || option.LinkedGrid === "InSituWaterSedimentObservation")
                                    url = `/datagrid/${params.row.StationType}/${params.row.ContainingNode}/${option.LinkedGrid}/StationID/${params.row.ObjectID}`;
                                else if(option.LinkedGrid === "InSituAirNoiseBiodiversityMeasurement")
                                    url = `/datagrid/${params.row.StationType}/${params.row.ContainingNode}/InSituAirNoiseBiodiversityRecord/StationID/${params.row.ObjectID}`;
                                else if(option.LinkedGrid === "StationSGWWellConstruction" || option.LinkedGrid === "StationSGWWellConstructionDetail" || option.LinkedGrid === "StationSGWLithology")
                                    url = `/datagrid/${params.row.StationType}/${params.row.ContainingNode}/${option.LinkedGrid}/StationSoilGroundwaterID/${params.row.ObjectID}`;
                                else if(option.LinkedGrid === "SedimentSampling")
                                    url = `/datagrid/${params.row.StationType}/${params.row.ContainingNode}/root/OTEntityID/${params.row.OTEntityID}`;
                                else if(option.LinkedGrid === "PhotoVideo" || option.LinkedGrid === "Documents")
                                    url = `/${option.LinkedGrid}/${params.row.StationType}/${params.id}/true/${params.row.OTEntityID}/${params.row.ContainingNode}`;
                                else
                                    url = `/datagrid/${option.LinkedGrid}/${params.row.ContainingNode}/root/OTEntityID/${params.row.OTEntityID}/${params.row.Name}`;
                                historyPush(history, url, { withBackButton: true });
                            }} 
                        >
                            <GridActionsCellItem
                                key={index}
                                label={option.ToolTip}
                                icon={
                                    <BasicTooltip title={option.ToolTip} placement="right">
                                        {getIconComponent(option.MUIIconName)}
                                    </BasicTooltip>
                                }
                            />
                            <Box sx={{typography:"body2"}}>{option.ToolTip}</Box>
                        </Box>
                    ));
            case "samplings":
                let filteredSamplingsOptions = samplingsOptions;
                if (params.row.SampleType === "Sediment" || params.row.SampleType === "Water") {
                    filteredSamplingsOptions = samplingsOptions.filter((option, index) => 
                        [0, 1, 4].includes(index)
                    );
                }
                else if (params.row.SampleType === "Biological" || params.row.SampleType === "Air") {
                    filteredSamplingsOptions = samplingsOptions.filter((option, index) => 
                        [0, 1, 3].includes(index)
                    );
                }
                else {
                    filteredSamplingsOptions = samplingsOptions.filter((option, index) => 
                        [0, 1, 2].includes(index)
                    );
                }

                return filteredSamplingsOptions
                    .sort((a, b) => a.Order - b.Order)
                    .map((option, index) => (
                        <Box
                            sx={{ display:"flex", cursor:"pointer", alignItems: "center", "&:hover": { backgroundColor: "action.hover" } }}
                            key={index}
                            onClick={() => {
                                let url = "";
                                if(option.LinkedGrid === "InSituUndergroundMeasurementObservation" || option.LinkedGrid === "InSituWaterSedimentObservation")
                                    url = `/datagrid/${params.row.SampleType}Sampling/${params.row.ContainingNode}/${option.LinkedGrid}/SamplingID/${params.id}`;
                                else if(option.LinkedGrid === "InSituAirNoiseBiodiversityMeasurement")
                                    url = `/datagrid/${params.row.SampleType}Sampling/${params.row.ContainingNode}/InSituAirNoiseBiodiversityRecord/SamplingID/${params.id}`;
                                else if(option.LinkedGrid === "PhotoVideo")
                                    url = `/${option.LinkedGrid}/${params.row.SampleType}Sampling/${params.id}/true/${params.row.OTEntityID}/${params.row.ContainingNode}`;
                                else
                                    url = `/datagrid/${params.row.SampleType}Sampling/${params.row.ContainingNode}/${option.LinkedGrid}/${option.SpecificParentFieldForChild}/${params.id}`;
                                historyPush(history, url, { withBackButton: true });
                            }} 
                        >
                            <GridActionsCellItem
                                key={index}
                                label={option.ToolTip}
                                icon={
                                    <BasicTooltip title={option.ToolTip} placement="right">
                                        {getIconComponent(option.MUIIconName)}
                                    </BasicTooltip>
                                }
                            />
                            <Box sx={{typography:"body2"}}>{option.ToolTip}</Box>
                        </Box>
                    ));
            default:
                return [];
        }
    };

    const [eddLineID, setEddLineID] = useState(false);
    const [openAlertDialog, setOpenAlertDialog] = useState(false);

    const [pageSize, setPageSize] = useState(10);
    const [entitiesSearch, setEntitiesSearch] = useState("");
    const [documentsSearch, setDocumentsSearch] = useState("");
    const [stationsSearch, setStationsSearch] = useState("");
    const [zonesSearch, setZonesSearch] = useState("");
    const [samplingsSearch, setSamplingsSearch] = useState("");

    const entitiesColumns = [
        { field: 'Code', headerName: t('field.Code'), flex: 1, sortable: true },
        { field: 'Name', headerName: t('field.Name'), flex: 1, sortable: true },
        {
            field: 'Branches',
            headerName: t('field.Branch'),
            flex: 1,
            sortable: true,
            valueGetter: params => {
                const branches = params.row.Branches?.map(item => {
                    return item.Value;
                });
                const brancheString = branches
                    ?.toString()
                    .replace(/,/g, ", ");
                
                return brancheString;
            }
        },
        ...entitiesActionsColumn
    ];
    
    const documentsColumns = [
        {
            field: 'CreatedOn',
            headerName: t('field.CreatedOn'),
            flex: 1,
            sortable: true,
            valueGetter: params => dateTimeToString(params.row.CreatedOn, "DateTime")
        },
        { field: 'Name', headerName: t('field.Name'), flex: 1, sortable: true },
        { field: 'Filename', headerName: t('field.Filename'), flex: 1, sortable: true },
        { field: 'Author', headerName: t('field.Author'), flex: 1, sortable: true },
        {
            field: 'Keywords',
            headerName: t('field.Keywords'),
            flex: 1,
            minWidth: 240,
            sortable: true,
            renderCell: (params) =>
                params.row.Keywords.map((option, index) => (
                    <Chip
                        key={option.ObjectID}
                        label={option.Name || option.Value}
                        style={{ backgroundColor:option.HexColor, color:"#006064", border:"1px", borderRadius:"14px"}}
                    />
                ))
        },
        { field: 'Category', headerName: t('field.Category'), flex: 1, sortable: true },
        { field: 'Shared', headerName: t('field.Shared'), flex: 1, sortable: true },
        ...defaultActionsColumn
    ];

    const DocumentDetailPanel = ({ row }) => {
        return (
            <Box sx={{ 
                width: "100%", 
                padding: 0,
                margin: 0,
                boxSizing: "border-box",
                overflow: "hidden"
            }}>
                <DataGridPro
                    autoHeight
                    rows={[row]}
                    columns={[
                        {
                            field: "Description",
                            headerName: t("field.Description"),
                            flex: 1,
                            minWidth: 0,
                            filterable: false,
                            sortable: false,
                            renderCell: params => (
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'break-word',
                                        width: '100%',
                                        padding: 1,
                                        margin: 0
                                    }}
                                >
                                    {params.row.Description}
                                </Typography>
                            )
                        }
                    ]}
                    hideFooter
                    disableColumnMenu
                    getRowId={row => row.ObjectID || row.id || 0}
                    getRowHeight={() => 'auto'}
                    disableSelectionOnClick
                    disableVirtualization
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        margin: 0,
                        padding: 0,
                        overflow: "hidden",
                        backgroundColor: "background.paper",
                        "& .MuiDataGrid-main": {
                            overflow: "hidden"
                        },
                        "& .MuiDataGrid-virtualScroller": {
                            overflow: "hidden !important"
                        },
                        "& .MuiDataGrid-cell": {
                            backgroundColor: "background.paper",
                            whiteSpace: "pre-wrap",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            alignItems: "flex-start",
                            padding: 1,
                            margin: 0,
                            maxWidth: "100%",
                            overflow: "hidden"
                        },
                        "& .MuiDataGrid-row": {
                            backgroundColor: "background.paper",
                            width: "100%",
                            maxWidth: "100%",
                            margin: 0
                        },
                        "& .MuiDataGrid-columnHeaders": {
                            backgroundColor: "background.paper",
                            margin: 0
                        },
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "background.paper",
                            margin: 0
                        }
                    }}
                />
            </Box>
        );
    };

    const stationsColumns = [
        {
            field: 'Alert',
            headerName: t('field.Alert'),
            flex: 1,
            sortable: true,
            renderCell: params => (
                <BasicTooltip
                    title={
                        params?.value
                            ? t("common.SeeAlerts")
                            : t("common.NoAlerts")
                    }
                >
                    <div>
                        <IconButton
                            disableRipple={!params?.value}
                            disabled={!params?.value}
                            onClick={() => {
                                setEddLineID(params.row.ID);
                                setOpenAlertDialog(true);
                            }}
                        >
                            {params?.value ? (
                                <WarningOutlinedIcon
                                    sx={{ width: 18, height: 18 }}
                                />
                            ) : (
                                <DoneOutlinedIcon
                                    sx={{ width: 18, height: 18 }}
                                />
                            )}
                        </IconButton>
                    </div>
                </BasicTooltip>
            ),
        },
        { field: 'Name', headerName: t('field.Name'), flex: 1, sortable: true },
        { field: 'OTEntityName', headerName: t('field.EntityName'), flex: 1, sortable: true },
        ...stationsActionsColumn
    ];

    const zonesColumns = [
        { field: 'Code', headerName: t('field.Code'), flex: 1, sortable: true },
        { field: 'Name', headerName: t('field.Name'), flex: 1, sortable: true },
        {
            field: 'Color',
            headerName: t('field.Valid'),
            flex: 1,
            sortable: true,
            renderCell: params =>
                params.row.Color && (
                    <ColorButton
                        disabled
                        tooltip={params.row.Color}
                        color={params.row.Color}
                    />
                ),
        },
        {
            field: 'Extent',
            headerName: t('field.Valid'),
            flex: 1,
            sortable: true,
            renderCell: params =>
                !params.value.GeoJSON ? (
                    <BasicTooltip title={t("view.zone.ExtendNotDefined")}>
                        <WarningOutlinedIcon color={"error"} />
                    </BasicTooltip>
                ) : (
                    <BasicTooltip title={t("view.zone.ExtendDefined")}>
                        <DoneIcon color={"secondary"} />
                    </BasicTooltip>
                ),
        },
    ];

    const samplingsColumns = [
        {
            field: 'Alert',
            headerName: t('field.Alert'),
            flex: 1,
            sortable: true,
            renderCell: params => (
                <BasicTooltip
                    title={
                        params?.value
                            ? t("common.SeeAlerts")
                            : t("common.NoAlerts")
                    }
                >
                    <div>
                        <IconButton
                            disableRipple={!params?.value}
                            disabled={!params?.value}
                            onClick={() => {
                                setEddLineID(params.row.ObjectID);
                                setOpenAlertDialog(true);
                            }}
                        >
                            {params?.value ? (
                                <WarningOutlinedIcon
                                    sx={{ width: 18, height: 18 }}
                                />
                            ) : (
                                <DoneOutlinedIcon
                                    sx={{ width: 18, height: 18 }}
                                />
                            )}
                        </IconButton>
                    </div>
                </BasicTooltip>
            ),
        },
        { field: 'SamplingID', headerName: t('field.SamplingID'), flex: 1, sortable: true },
        { field: 'SubSamplingID', headerName: t('field.SubSamplingID'), flex: 1, sortable: true },
        { field: 'Station', headerName: t('field.Station'), flex: 1, sortable: true },
        {
            field: 'SampleType',
            headerName: t('field.SampleType'),
            flex: 1,
            sortable: true,
            valueGetter: params => {
                return params.row.SampleType.split(/(?=[A-Z])/).filter(part => part.length > 0).join(" ");
            }
        },
        { field: 'SampleCollectionType', headerName: t('field.SampleCollectionType'), flex: 1, sortable: true },
        ...samplingsActionsColumn
    ];

    const [entitiesSortModel, setEntitiesSortModel] = useState([
        { field: "Code", sort: "asc" }
    ]);

    const [documentsSortModel, setDocumentsSortModel] = useState([
        { field: "Filename", sort: "asc" }
    ]);

    const [stationsSortModel, setStationsSortModel] = useState([
        { field: "Name", sort: "asc" }
    ]);

    const [zonesSortModel, setZonesSortModel] = useState([
        { field: "Name", sort: "asc" }
    ]);
    const [samplingsSortModel, setSamplingsSortModel] = useState([
        { field: "SamplingID", sort: "asc" }
    ]);

    const filteredEntitiesResults = entitiesResults
        ? entitiesResults.filter(row => {
            const branchesString = row.Branches?.map(item => item.Value).join(", ") || "";
            
            return (
                row.Code?.toLowerCase().includes(entitiesSearch.toLowerCase()) ||
                row.Name?.toLowerCase().includes(entitiesSearch.toLowerCase()) ||
                branchesString.toLowerCase().includes(entitiesSearch.toLowerCase())
            );
        })
        : [];

    const filteredDocumentsResults = documentsResults
        ? documentsResults.filter(row => {
            const keywordsString = row.Keywords?.map(keyword => keyword.Name || keyword.Value).join(", ") || "";
            
            return (
                row.Name?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                row.Filename?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                row.Author?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                row.Category?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                row.Shared?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                keywordsString.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                dateTimeToString(row.CreatedOn, "DateTime")?.toLowerCase().includes(documentsSearch.toLowerCase()) ||
                row.Description?.toLowerCase().includes(documentsSearch.toLowerCase())
            );
        })
        : [];

    const filteredStationsResults = stationsResults
        ? stationsResults.filter(row =>
            row.Name?.toLowerCase().includes(stationsSearch.toLowerCase()) ||
            row.OTEntityName?.toLowerCase().includes(stationsSearch.toLowerCase())
        )
        : [];

    const filteredZonesResults = zonesResults
        ? zonesResults.filter(row =>
            row.Code?.toLowerCase().includes(zonesSearch.toLowerCase()) ||
            row.Name?.toLowerCase().includes(zonesSearch.toLowerCase()) ||
            row.Color?.toLowerCase().includes(zonesSearch.toLowerCase()) ||
            row.OTEntityName?.toLowerCase().includes(zonesSearch.toLowerCase())
        )
        : [];

    const filteredSamplingsResults = samplingsResults
        ? samplingsResults.filter(row => {
            const sampleTypeFormatted = row.SampleType?.split(/(?=[A-Z])/).filter(part => part.length > 0).join(" ") || "";
            return (
                row.SamplingID?.toLowerCase().includes(samplingsSearch.toLowerCase()) ||
                row.SubSamplingID?.toLowerCase().includes(samplingsSearch.toLowerCase()) ||
                row.Station?.toLowerCase().includes(samplingsSearch.toLowerCase()) ||
                row.SampleType?.toLowerCase().includes(samplingsSearch.toLowerCase()) ||
                sampleTypeFormatted.toLowerCase().includes(samplingsSearch.toLowerCase()) ||
                row.SampleCollectionType?.toLowerCase().includes(samplingsSearch.toLowerCase())
            );
        })
        : [];

    const AlertGridDialog = useCallback(() => {
        return (
            <AlertDetailGrid
                toolbar={{
                    disableToolbar: true,
                }}
                otEntityID={currentEntity.ObjectID}
                eddLineID={eddLineID}
                isAdvancedSelectorGrid
                disableTitle
                isStandalone={false}
            />
        );
    }, [eddLineID]);

    const userSearchInput = useSelector(state => state.userPref.QuickSearch);

    const [noFileTypeSelected, setNoFileTypeSelected] = useState("");
    const [noStateSelected, setNoStateSelected] = useState("");
    const [noCategorySelected, setNoCategorySelected] = useState("");
    const [noEntityStatusSelected, setNoEntityStatusSelected] = useState("");
    const [noDateSelected, setNoDateSelected] = useState("");
    const [noKeywordsSelected, setNoKeywordsSelected] = useState("");

    return (
        <Paper square sx={{ padding: 2 }} elevation={0}>
            <Typography variant="subtitle1" sx={{ my: 1 }}>
                {t("common.ResultsFor", {
                    value: `"${searchInput.includes("|") ? searchInput.split("|")[0] : (searchInput==="[all]" ? "" : searchInput)}"`,
                })}{" "}
                :
            </Typography>
            {openAlertDialog ? (
                <Suspense fallback={null}>
                    <BasicDialog
                        label={t("dialog.Alerts")}
                        open={openAlertDialog}
                        closeDialog={() => setOpenAlertDialog(false)}
                        Content={AlertGridDialog}
                    />
                </Suspense>
            ) : null}
            
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <IconButton
                    onClick={handleToggleFilters}
                    color={showFilters ? "primary" : "default"}
                    size="small"
                    disableRipple
                >
                    {showFilters ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
                    <Box sx={{ typography:"bodyMajor" }}>
                        {t("common.AdvancedSearchCriteria")}
                    </Box>
                </IconButton>
            </Box>
              
            <Collapse in={showFilters}>
                <Paper 
                    elevation={2} 
                    sx={{ 
                        p: 2, 
                        mb: 2,
                        backgroundColor: "background.paper",
                        border: 1,
                        borderColor: "divider",
                        overflowX: "hidden",
                        width: "100%",
                        boxSizing: "border-box",
                        position: "relative"
                    }}
                >
                    <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, flexWrap: "wrap", overflowX: "hidden", width:"100%"}}>
                        {/* Right side: Split into two columns */}
                        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, flex: 1 }}>
                            {/* Left column: Entities */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1, mr: 15, mb:3 }}>
                                {localCategories.map((item, index) => (
                                    item.label === "Entities" && (
                                        <FormControl key={index} sx={{ width: "150%" }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={localCategories[index].checked}
                                                        disabled={false}
                                                        onChange={(e) => {
                                                            const updatedCategories = [...localCategories];
                                                            updatedCategories[index].checked = e.target.checked;
                                                            setLocalCategories(updatedCategories);
                                                            // Check if this is the new entity tree view structure
                                                            const isNewEntityTreeView = item.submenu && 
                                                                item.submenu.length > 0 && 
                                                                item.submenu[0].BranchCode !== null && 
                                                                item.submenu[0].BranchCode !== undefined;
                                                            
                                                            if (isNewEntityTreeView) {
                                                                // Update all submenu items when toggling entities (new structure)
                                                                if (updatedCategories[index].submenu) {
                                                                    updatedCategories[index].submenu = updatedCategories[index].submenu.map(branch => ({
                                                                        ...branch,
                                                                        Checked: e.target.checked,
                                                                        Countries: branch.Countries.map(country => ({
                                                                            ...country,
                                                                            Checked: e.target.checked,
                                                                            OTEntities: country.OTEntities.map(entity => ({
                                                                                ...entity,
                                                                                Checked: e.target.checked,
                                                                            })),
                                                                        })),
                                                                    }));
                                                                }
                                                            } else {
                                                                // Update all submenu items when toggling entities (old structure)
                                                                if (updatedCategories[index].submenu) {
                                                                    updatedCategories[index].submenu = updatedCategories[index].submenu.map(subItem => ({
                                                                        ...subItem,
                                                                        checked: e.target.checked,
                                                                        Checked: e.target.checked
                                                                    }));
                                                                }
                                                            }

                                                            
                                                            dispatch(updateSearchCategoriesImmediate(updatedCategories));
                                                            
                                                            // dispatch(updateQuickSearchFilter({
                                                            //     ...quickSearchFilter,
                                                            //     SearchCategories: updatedCategories
                                                            // }));
                                                        }}
                                                    />
                                                }
                                                label={t(`grid.title.${item.label}`)}
                                            />
                                            {item.submenu?.length > 0 && (
                                                <Box sx={{ pl: 3, display: "flex", flexDirection: "column", gap: 0.5, height: 350, overflowY: "auto" }}>
                                                    {/* Check if this is the new entity tree view structure */}
                                                    {item.submenu[0].BranchCode !== null && item.submenu[0].BranchCode !== undefined ? (
                                                        // New entity tree view structure
                                                        item.submenu.map((branchItem, branchIndex) => (
                                                            <Box key={branchIndex}>
                                                                <Box
                                                                    sx={{
                                                                        typography: "body1",
                                                                        pt: 1,
                                                                        cursor: "pointer",
                                                                        display: "flex",
                                                                        alignItems: "center"
                                                                    }}
                                                                    onClick={() => {
                                                                        setExpandedBranches(prev =>
                                                                            prev.includes(branchItem.BranchCode)
                                                                                ? prev.filter(code => code !== branchItem.BranchCode)
                                                                                : [...prev, branchItem.BranchCode]
                                                                        );
                                                                    }}
                                                                >
                                                                    <Checkbox
                                                                        size="small"
                                                                        checked={branchItem.Checked || false}
                                                                        onChange={e => {
                                                                            const updatedCategories = JSON.parse(JSON.stringify(localCategories));
                                                                            const entities = updatedCategories[0];
                                                                            if (entities && entities.submenu) {
                                                                                entities.submenu = entities.submenu.map((branch, idx) =>
                                                                                    idx === branchIndex
                                                                                        ? {
                                                                                            ...branch,
                                                                                            Checked: e.target.checked,
                                                                                            Countries: branch.Countries.map(country => ({
                                                                                                ...country,
                                                                                                Checked: e.target.checked,
                                                                                                OTEntities: country.OTEntities.map(entity => ({
                                                                                                    ...entity,
                                                                                                    Checked: e.target.checked
                                                                                                }))
                                                                                            }))
                                                                                        }
                                                                                        : branch
                                                                                );
                                                                                // Update parent checked state
                                                                                entities.checked = entities.submenu.some(b => b.Checked);
                                                                            }
                                                                            setLocalCategories(updatedCategories);
                                                                            dispatch(updateSearchCategoriesImmediate(updatedCategories));
                                                                        }}
                                                                        onClick={e => e.stopPropagation()}
                                                                        sx={{ mr: 1, p: 0.5 }}
                                                                    />
                                                                    <span>{branchItem.BranchCode}</span>
                                                                </Box>
                                                                {expandedBranches.includes(branchItem.BranchCode) && branchItem.Countries.map((countryItem, countryIndex) => (
                                                                    <Box sx={{ ml: 3.5, mb: 1.5 }} key={countryIndex}>
                                                                        <Box sx={{ display: "flex", alignItems: "center", fontFamily: "arial", fontSize: "13px" }}>
                                                                            <Checkbox
                                                                                size="small"
                                                                                checked={countryItem.Checked || false}
                                                                                onChange={e => {
                                                                                    const updatedCategories = JSON.parse(JSON.stringify(localCategories));
                                                                                    const entities = updatedCategories[0];
                                                                                    if (entities && entities.submenu) {
                                                                                        entities.submenu = entities.submenu.map((branch, bIdx) => {
                                                                                            if (bIdx === branchIndex) {
                                                                                                const updatedCountries = branch.Countries.map((country, cIdx) =>
                                                                                                    cIdx === countryIndex
                                                                                                        ? {
                                                                                                            ...country,
                                                                                                            Checked: e.target.checked,
                                                                                                            OTEntities: country.OTEntities.map(entity => ({
                                                                                                                ...entity,
                                                                                                                Checked: e.target.checked
                                                                                                            }))
                                                                                                        }
                                                                                                        : country
                                                                                                );
                                                                                                // Update branch checked state
                                                                                                const isBranchChecked = updatedCountries.some(c => c.Checked);
                                                                                                return {
                                                                                                    ...branch,
                                                                                                    Countries: updatedCountries,
                                                                                                    Checked: isBranchChecked
                                                                                                };
                                                                                            }
                                                                                            return branch;
                                                                                        });
                                                                                        // Update parent checked state
                                                                                        entities.checked = entities.submenu.some(b => b.Checked);
                                                                                    }
                                                                                    setLocalCategories(updatedCategories);
                                                                                    dispatch(updateSearchCategoriesImmediate(updatedCategories));
                                                                                }}
                                                                                sx={{ mr: 1, p: 0.5 }}
                                                                            />
                                                                            <span>{countryItem.CountryName}</span>
                                                                        </Box>
                                                                        {countryItem.OTEntities.map((subItem, subIndex) => (
                                                                            <FormControlLabel
                                                                                key={subIndex}
                                                                                control={
                                                                                    <Checkbox
                                                                                        checked={subItem.Checked || false}
                                                                                        onChange={(e) => {
                                                                                            const updatedCategories = JSON.parse(JSON.stringify(localCategories));
                                                                                            const entities = updatedCategories[0];
                                                                                            if (entities && entities.submenu) {
                                                                                                entities.submenu = entities.submenu.map((branch, bIdx) => {
                                                                                                    if (bIdx === branchIndex) {
                                                                                                        const updatedCountries = branch.Countries.map((country, cIdx) => {
                                                                                                            if (cIdx === countryIndex) {
                                                                                                                const updatedEntities = country.OTEntities.map((entity, eIdx) =>
                                                                                                                    eIdx === subIndex
                                                                                                                        ? { ...entity, Checked: e.target.checked }
                                                                                                                        : entity
                                                                                                                );
                                                                                                                // Update country checked state
                                                                                                                const isCountryChecked = updatedEntities.some(e => e.Checked);
                                                                                                                return {
                                                                                                                    ...country,
                                                                                                                    OTEntities: updatedEntities,
                                                                                                                    Checked: isCountryChecked
                                                                                                                };
                                                                                                            }
                                                                                                            return country;
                                                                                                        });
                                                                                                        // Update branch checked state
                                                                                                        const isBranchChecked = updatedCountries.some(c => c.Checked);
                                                                                                        return {
                                                                                                            ...branch,
                                                                                                            Countries: updatedCountries,
                                                                                                            Checked: isBranchChecked
                                                                                                        };
                                                                                                    }
                                                                                                    return branch;
                                                                                                });
                                                                                                // Update parent checked state
                                                                                                entities.checked = entities.submenu.some(b => b.Checked);
                                                                                            }
                                                                                            setLocalCategories(updatedCategories);
                                                                                            dispatch(updateSearchCategoriesImmediate(updatedCategories));
                                                                                        }}
                                                                                        sx={{ transform: "scale(0.9)" }}
                                                                                    />
                                                                                }
                                                                                label={subItem.Label}
                                                                                sx={{
                                                                                    "& .MuiFormControlLabel-label": {
                                                                                        fontSize: 11.8,
                                                                                        whiteSpace: "nowrap",
                                                                                        overflow: "hidden",
                                                                                        textOverflow: "ellipsis",
                                                                                        maxWidth: "200px"
                                                                                    },
                                                                                    mb: "-15px",
                                                                                    ml: 3,
                                                                                    display: "block",
                                                                                    width: "100%",
                                                                                    maxWidth: "100%"
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                ))}
                                                            </Box>
                                                        ))
                                                    ) : (
                                                        // Old structure - simple list
                                                        item.submenu.map((subItem, subIdx) => (
                                                            <Box key={subIdx}>
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            size="small"
                                                                            checked={subItem.checked || subItem.Checked}
                                                                            onChange={(e) => {
                                                                                const updatedCategories = JSON.parse(JSON.stringify(localCategories));
                                                                                const entities = updatedCategories[0];
                                                                                if (entities && entities.submenu) {
                                                                                    // Use a unique property if possible, otherwise subIdx
                                                                                    entities.submenu = entities.submenu.map((s, idx) =>
                                                                                        idx === subIdx
                                                                                            ? { ...s, checked: e.target.checked, Checked: e.target.checked }
                                                                                            : s
                                                                                    );
                                                                                    // Update parent checked state based on children
                                                                                    const anyChecked = entities.submenu.some(s => s.checked || s.Checked);
                                                                                    entities.checked = anyChecked;
                                                                                }
                                                                                setLocalCategories(updatedCategories); // Update local UI state
                                                                                dispatch(updateSearchCategoriesImmediate(updatedCategories)); // Sync to Redux if needed
                                                                            }}
                                                                        />
                                                                    }
                                                                    label={subItem.label || subItem.BranchCode}
                                                                    sx={{
                                                                        mb:-2,
                                                                        "& .MuiFormControlLabel-label": {
                                                                            fontSize: 12,
                                                                        }
                                                                    }}
                                                                />
                                                            </Box>
                                                        ))
                                                    )}
                                                </Box>
                                            )}
                                        </FormControl>
                                    )
                                ))}
                            </Box>
                            
                            {/* Right column: Other categories */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1, ml: 4 }}>
                                {quickSearchFilter?.SearchCategories?.map((item, index) => (

                                    item.label !== "Entities" && (
                                        <FormControl key={index} sx={{ width: "100%" }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={localCategories[index].checked}
                                                        disabled={false}
                                                        onChange={(e) => {
                                                            const updatedCategories = [...localCategories];
                                                            updatedCategories[index].checked = e.target.checked;
                                                            setLocalCategories(updatedCategories);
                                                            
                                                            // If Documents is toggled, update related filter criterias
                                                            if (item.label === "Documents") {

                                                                const updatedCriterias = filterCriterias.map(criteria => {
                                                                    if (["FileType", "Category", "State", "KeywordsOnly", "Date"].includes(criteria.value)) {
                                                                        return {
                                                                            ...criteria,
                                                                            checked: !e.target.checked ? false : criteria.checked,
                                                                            disabled: !e.target.checked
                                                                        };
                                                                    }
                                                                    return criteria;
                                                                });
                                                                
                                                                setFilterCriterias(updatedCriterias);
                                                            }

                                                            console.log("count",maxResultCount);

                                                            dispatch(updateSearchCategoriesImmediate(updatedCategories));
                                                            
                                                            // dispatch(updateQuickSearchFilter({
                                                            //     ...quickSearchFilter,
                                                            //     SearchCategories: updatedCategories
                                                            // }));
                                                        }}
                                                    />
                                                }
                                                label={t(`grid.title.${item.label}`)}
                                            />
                                        </FormControl>
                                    )
                                ))}
                                
                                <Box sx={{ alignItems: "center", gap: 1, mt: 2 }}>
                                    <Box sx={{ typography: "body1" }}>{t("field.ResultsSize")}:</Box>
                                    <Select
                                       defaultValue={maxResultOptions.find(opt => opt.value === maxResultCount)}
                                        size="small"
                                        variant="standard"
                                        onChange={(e, option) => {
                                            setMaxResultCount(option.value);
                                            dispatch(updateMaxResultCount(option.value));
                                        }}
                                        sx={{ minWidth: 60 }}
                                        options={maxResultOptions}
                                    />
                                </Box>
                            </Box>
                        </Box>
                        
                        <Divider 
                            sx={{ 
                                mr: 4,
                                display: { sm: "none", md: "block" }
                            }} 
                            orientation="vertical" 
                            flexItem 
                        />
                        {/* <Divider 
                            sx={{ 
                                my: 2, 
                                display: { xs: "block", md: "none" }
                            }} 
                            orientation="horizontal" 
                            flexItem 
                        /> */}

                        {/* Left side: Advanced search criteria with search operators */}
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
                            {/* Search operators */}
                            {(() => {
                                const normalCriterias = filterCriterias.filter(
                                    item =>
                                        item.value !== "KeywordsOnly"
                                        && item.value !== "Date"
                                        && item.value !== "FileType"
                                        && item.value !== "State"
                                        && item.value !== "Category"
                                        && item.value !== "EntityStatus"
                                );
                                
                                const rows = [];
                                if (normalCriterias.length >= 4) {
                                    rows.push(
                                        <Box key="first-row">
                                            {normalCriterias.slice(0, 4).map((criteria, index) => (
                                                <FormControl key={index} sx={{ width: 180 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                name={criteria.value}
                                                                onChange={e => updateFilterCriterias(e)}
                                                                checked={criteria.checked}
                                                                disabled={criteria.disabled || false}
                                                            />
                                                        }
                                                        label={t(`common.${criteria.value}`)}
                                                    />
                                                </FormControl>
                                            ))}
                                        </Box>
                                    );
                                }
                                
                                for (let i = 4; i < normalCriterias.length; i += 2) {
                                    rows.push(
                                        <Box key={i} sx={{ display: "flex", gap: 2 }}>
                                            <FormControl sx={{ width: 210 }}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            label={t(`common.${normalCriterias[i].value}`)}
                                                            onChange={e => updateFilterCriterias(e)}
                                                            checked={normalCriterias[i].checked}
                                                            disabled={normalCriterias[i].disabled || false}
                                                        />
                                                    }
                                                    label={t(`common.${normalCriterias[i].value}`)}
                                                />
                                            </FormControl>
                                            {normalCriterias[i + 1] && (
                                                <FormControl sx={{ width: 210 }}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                label={t(`common.${normalCriterias[i + 1].value}`)}
                                                                onChange={e => updateFilterCriterias(e)}
                                                                checked={normalCriterias[i + 1].checked}
                                                                disabled={normalCriterias[i + 1].disabled || false}
                                                            />
                                                        }
                                                        label={t(`common.${normalCriterias[i + 1].value}`)}
                                                    />
                                                </FormControl>
                                            )}
                                        </Box>
                                    );
                                }
                                
                                return rows;
                            })()}

                            {/* Document filter options */}
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mt:-1 }}>
                                <FormControl sx={{ mb:-2, display:"flex", flexDirection:"row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="KeywordsOnly"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.value === "KeywordsOnly")?.checked || false}
                                                disabled={filterCriterias.find(c => c.value === "KeywordsOnly")?.disabled || false}
                                            />
                                        }
                                        label={`${t("common.KeywordsOnly")}:`}
                                    />
                                    <Box sx={{ typography:"bodyMajor", mt:1.6 }}>{noKeywordsSelected}</Box>
                                </FormControl>
                                <KeywordsSelectURL
                                    URL={"keyword"}
                                    multiple
                                    sx={{ width: 260 }}
                                    value={
                                        Array.isArray(filterCriterias.find(c => c.value === "KeywordsOnly")?.selected)
                                            ? filterCriterias.find(c => c.value === "KeywordsOnly")?.selected
                                            : []
                                    }
                                    onChange={(event, value) => handleFilterKeywordsChange(value)}
                                    disabled={!filterCriterias.find(c => c.value === "KeywordsOnly")?.checked}
                                    variant="standard"
                                />
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <FormControl sx={{ mb:-2, display:"flex", flexDirection:"row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="Date"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.label === "Date")?.checked || false}
                                                disabled={filterCriterias.find(c => c.label === "Date")?.disabled || false}
                                            />
                                        }
                                        label={`${t("common.Date")}:`}
                                    />
                                    <Box sx={{ typography:"bodyMajor", mt:1.6 }}>{noDateSelected}</Box>
                                </FormControl>
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <FormProvider {...filterMethods}>
                                        <VDateOnlyPicker
                                            fieldName="filterStartDate"
                                            defaultValue={filterStartDate}
                                            setDate={handleFilterStartDateChange}
                                            disabled={!filterCriterias.find(c => c.value === "Date")?.checked}
                                            slotProps={{
                                                popper: {
                                                    sx: { zIndex: 1300 },
                                                    placement: "bottom"
                                                },
                                                textField: {
                                                    margin: "dense",
                                                    size: "small",
                                                    sx: { width: 115 },
                                                    variant: "standard"
                                                }
                                            }}
                                        />
                                        <Box sx={{ typography: "body1", mx: 1 }}>to</Box>
                                        <VDateOnlyPicker
                                            fieldName="filterEndDate"
                                            defaultValue={filterEndDate}
                                            setDate={handleFilterEndDateChange}
                                            disabled={!filterCriterias.find(c => c.value === "Date")?.checked}
                                            slotProps={{
                                                popper: {
                                                    sx: { zIndex: 1300 },
                                                    placement: "bottom"
                                                },
                                                textField: {
                                                    margin: "dense",
                                                    size: "small",
                                                    sx: { width: 115 },
                                                    variant: "standard"
                                                }
                                            }}
                                        />
                                    </FormProvider>
                                </Box>
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <FormControl sx={{ mb:-3, display:"flex", flexDirection:"row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="FileType"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.value === "FileType")?.checked || false}
                                                disabled={filterCriterias.find(c => c.value === "FileType")?.disabled || false}
                                            />
                                        }
                                        label={`${t("common.FileType")}:`}
                                    />
                                    <Box sx={{ typography:"bodyMajor", mt:1.6 }}>{noFileTypeSelected}</Box>
                                </FormControl>
                                <Autocomplete
                                    key={`filetype-${selectedFilterFileType?.value || 'null'}`}
                                    options={fileTypeOptions.sort((a, b) => a.label.localeCompare(b.label))}
                                    value={selectedFilterFileType}
                                    onChange={(event, newValue) => {
                                        setSelectedFilterFileType(newValue);
                                        filterMethods.setValue("filterFileType", newValue);
                                        const updated = filterCriterias.map(item =>
                                            item.value === "FileType"
                                                ? { ...item, selected: newValue }
                                                : item
                                        );
                                        setFilterCriterias(updated);

                                        dispatch(updateQuickSearchFilter({
                                            ...quickSearchFilter,
                                            SearchCriterias: updated
                                        }));
                                        if (newValue) {
                                            setNoFileTypeSelected("");
                                        }
                                    }}
                                    noOptionsText={"No options"}
                                    disabled={!filterCriterias.find(c => c.value === "FileType")?.checked}
                                    
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            sx={{ width: 260 }}
                                            margin="dense"
                                        />
                                    )}
                                />
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <FormControl sx={{ mb:-3, display:"flex", flexDirection:"row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="State"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.value === "State")?.checked || false}
                                                disabled={filterCriterias.find(c => c.value === "State")?.disabled || false}
                                            />
                                        }
                                        label={`${t("field.State")}:`}
                                    />
                                    <Box sx={{ typography:"bodyMajor", mt:1.6 }}>{noStateSelected}</Box>
                                </FormControl>
                                <Autocomplete
                                    key={`state-${selectedFilterState?.value || 'null'}`}
                                    options={fileStates}
                                    value={selectedFilterState}
                                    onChange={(event, newValue) => {
                                        setSelectedFilterState(newValue);
                                        filterMethods.setValue("filterState", newValue);
                                        const updated = filterCriterias.map(item =>
                                            item.value === "State"
                                                ? { ...item, selected: newValue }
                                                : item
                                        );
                                        setFilterCriterias(updated);

                                        dispatch(updateQuickSearchFilter({
                                            ...quickSearchFilter,
                                            SearchCriterias: updated
                                        }));
                                        if (newValue) {
                                            setNoStateSelected("");
                                        }
                                    }}
                                    disabled={!filterCriterias.find(c => c.value === "State")?.checked}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            sx={{ width: 260 }}
                                            margin="dense"
                                        />
                                    )}
                                />
                            </Box>

                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <FormControl sx={{ mb:-3, display:"flex", flexDirection:"row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="Category"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.value === "Category")?.checked || false}
                                                disabled={filterCriterias.find(c => c.value === "Category")?.disabled || false}
                                            />
                                        }
                                        label={`${t("field.Category")}:`}
                                    />
                                    <Box sx={{ typography:"bodyMajor", mt:1.6 }}>{noCategorySelected}</Box>
                                </FormControl>
                                <Autocomplete
                                    key={`category-${selectedFilterCategory?.value || 'null'}`}
                                    options={categoryOptions}
                                    value={selectedFilterCategory}
                                    onChange={(event, newValue) => {
                                        setSelectedFilterCategory(newValue);
                                        filterMethods.setValue("filterCategory", newValue);
                                        const updated = filterCriterias.map(item =>
                                            item.value === "Category"
                                                ? { ...item, selected: newValue }
                                                : item
                                        );
                                        setFilterCriterias(updated);

                                        dispatch(updateQuickSearchFilter({
                                            ...quickSearchFilter,
                                            SearchCriterias: updated
                                        }));
                                        if (newValue) {
                                            setNoCategorySelected("");
                                        }
                                    }}
                                    disabled={!filterCriterias.find(c => c.value === "Category")?.checked}
                                    freeSolo
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            sx={{ width: 260 }}
                                            margin="dense"
                                        />
                                    )}
                                />
                            </Box>
                            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <FormControl sx={{ mb: -3, display: "flex", flexDirection: "row" }}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="EntityStatus"
                                                onChange={e => updateFilterCriterias(e)}
                                                checked={filterCriterias.find(c => c.value === "EntityStatus")?.checked || false}
                                                disabled={!entitiesSearchEnabled || filterCriterias.find(c => c.value === "EntityStatus")?.disabled || false}
                                            />
                                        }
                                        label={`${t("field.EntityStatus")}:`}
                                    />
                                    <Box sx={{ typography: "bodyMajor", mt: 1.6 }}>{noEntityStatusSelected}</Box>
                                </FormControl>
                                <Autocomplete
                                    options={entityStatuses}
                                    value={selectedFilterEntityStatus}
                                    isOptionEqualToValue={(option, selected) => option.value === selected.value}
                                    onChange={(event, newValue) => {
                                        setSelectedFilterEntityStatus(newValue);
                                        setNoEntityStatusSelected("");
                                        const updated = filterCriterias.map(item =>
                                            item.value === "EntityStatus"
                                                ? { ...item, selected: newValue }
                                                : item
                                        );
                                        setFilterCriterias(updated);
                                        dispatch(updateQuickSearchFilter({
                                            ...quickSearchFilter,
                                            SearchCriterias: updated
                                        }));
                                    }}
                                    disabled={!entitiesSearchEnabled || !filterCriterias.find(c => c.value === "EntityStatus")?.checked}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="standard"
                                            size="small"
                                            sx={{ width: 260 }}
                                            margin="dense"
                                        />
                                    )}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            position: "absolute",
                            bottom: 16,
                            right: 9,
                            zIndex: 2,
                            display: { xs: "none", md: "flex" }
                        }}
                    >
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => {
                                let input = userSearchInput;
                                input = input.replaceAll("/","-");
                                const keywordsSelected = filterCriterias.find(c => c.value === "KeywordsOnly")?.checked;
                                const selectedKeywords = filterCriterias.find(c => c.value === "KeywordsOnly")?.selected;
                                const fileTypeChecked = filterCriterias.find(c => c.value === "FileType")?.checked;
                                const stateChecked = filterCriterias.find(c => c.value === "State")?.checked;
                                const categoryChecked = filterCriterias.find(c => c.value === "Category")?.checked;
                                const entityStatusChecked = filterCriterias.find(c => c.value === "EntityStatus")?.checked;
                                const rawStartDate = filterCriterias.find(c => c.value === "Date")?.startDate || filterStartDate;
                                const rawEndDate = filterCriterias.find(c => c.value === "Date")?.endDate || filterEndDate;
                                const formattedStartDate = rawStartDate ? dayjs(rawStartDate).format("DD-MM-YYYY") : "";
                                const formattedEndDate = rawEndDate ? dayjs(rawEndDate).format("DD-MM-YYYY") : "";
                                const dateSelected = filterCriterias.find(c => c.value === "Date")?.checked;
                                
                                let noOptionSelected = false;

                                if (entityStatusChecked) {
                                    if (selectedFilterEntityStatus?.value) {
                                        setNoEntityStatusSelected("");
                                    } else {
                                        setNoEntityStatusSelected(t("input.validation.required"));
                                        noOptionSelected = true;
                                    }
                                } else {
                                    setNoEntityStatusSelected("");
                                }

                                const cleanInput = (str) => {
                                    return str
                                        .replace(/\|\s+/g, '|')
                                        .replace(/\s+$/g, '');
                                };
                                
                                if(fileTypeChecked){
                                    if(selectedFilterFileType && (selectedFilterFileType.value || selectedFilterFileType.label)){
                                        setNoFileTypeSelected("");
                                        let fileTypeValue = selectedFilterFileType.value || selectedFilterFileType.label;
                                        if(fileTypeValue){
                                            if(fileTypeValue.startsWith((".")))
                                                fileTypeValue = fileTypeValue.substring(1);
                                        }
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\.(.*?)\./);
                                            if (match && match[1]) {
                                                input = input.replace(`.${match[1]}.`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|")
                                                    input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " ." + fileTypeValue + ".";
                                            else
                                                input += "|." + fileTypeValue + ".";
                                        }
                                        else{
                                            input += "|." + fileTypeValue + ".";
                                        }
                                    }
                                    else{
                                        setNoFileTypeSelected("No file type selected!");
                                        noOptionSelected = true;
                                    }
                                }
                                else{
                                    const match = input.match(/\.(.*?)\./);
                                    if (match && match[0]) {
                                        input = input.replace(match[0], "");
                                        input = cleanInput(input);
                                        if(input[input.length - 1] === "|")
                                            input = input.slice(0, -1);
                                    }
                                }
                                if(stateChecked){
                                    if(selectedFilterState && (selectedFilterState.value || selectedFilterState.label)){
                                        setNoStateSelected("");
                                        const stateValue = selectedFilterState.value || selectedFilterState.label;
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\$(.*?)\$/);
                                            if (match && match[1]) {
                                                input = input.replace(`$${match[1]}$`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|")
                                                    input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " $" + stateValue + "$";
                                            else
                                                input += "|$" + stateValue + "$";
                                        }
                                        else{
                                            input += "|$" + stateValue + "$";
                                        }
                                    }
                                    else{
                                        setNoStateSelected("No state selected!");
                                        noOptionSelected = true;
                                    }
                                }
                                else{
                                    const match = input.match(/\$(.*?)\$/);
                                    if (match && match[1]) {
                                        input = input.replace(`\$${match[1]}$`, "");
                                        input = cleanInput(input);
                                        if(input[input.length - 1] === "|")
                                            input = input.slice(0, -1);
                                    }
                                }
                                if(categoryChecked){
                                    if(selectedFilterCategory && (selectedFilterCategory.value || selectedFilterCategory.label)){
                                        setNoCategorySelected("");
                                        const categoryValue = selectedFilterCategory.value || selectedFilterCategory.label;
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\<(.*?)\>/);
                                            if (match && match[1]) {
                                                input = input.replace(`<${match[1]}>`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|")
                                                    input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " <" + categoryValue + ">";
                                            else
                                                input += "|<" + categoryValue + ">";
                                        }
                                        else{
                                            input += "|<" + categoryValue + ">";
                                        }
                                    }
                                    else{
                                        setNoCategorySelected("No category selected!");
                                        noOptionSelected = true;
                                    }
                                }
                                else{
                                    const match = input.match(/\<(.*?)\>/);
                                    if (match && match[1]) {
                                        input = input.replace(`\<${match[1]}\>`, "");
                                        input = cleanInput(input);
                                        if(input[input.length - 1] === "|")
                                            input = input.slice(0, -1);
                                    }
                                }
                                if(dateSelected){
                                    if (formattedStartDate && formattedEndDate) {
                                        const parseDate = (dateString) => {
                                            const parts = dateString.split('-');
                                            if (parts.length === 3) {
                                                const day = parseInt(parts[0], 10);
                                                const month = parseInt(parts[1], 10) - 1;
                                                const year = parseInt(parts[2], 10);
                                                return dayjs(new Date(year, month, day));
                                            }
                                            return null;
                                        };
                                        
                                        const startDateObj = parseDate(formattedStartDate);
                                        const endDateObj = parseDate(formattedEndDate);
                                        
                                        if (!startDateObj?.isValid() || !endDateObj?.isValid()) {
                                            setNoDateSelected(t("input.validation.InvalidDate"));
                                            return;
                                        }
                                        
                                        if (startDateObj.isAfter(endDateObj)) {
                                            setNoDateSelected(t("input.validation.DateRangeValidation"));
                                            return;
                                        }
                                    }
                                    const selectedDates = formattedStartDate + ";" + formattedEndDate;
                                    if(selectedDates.length > 1){
                                        setNoDateSelected("");
                                        if (input.includes("|")) {
                                            const match = searchInput.match(/\:(.*?)\:/);
                                            if (match && match[1]) {
                                                input = input.replace(`:${match[1]}:`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|")
                                                    input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " :" + selectedDates+":";
                                            else
                                                input += "|:" + selectedDates+":";
                                        }
                                        else {
                                            input += "|:" + selectedDates + ":";
                                        }
                                    }
                                    else{
                                        setNoDateSelected("No date selected!");
                                        noOptionSelected = true;
                                    }
                                }
                                else{
                                    const match = input.match(/\:(.*?)\:/);
                                    if (match && match[1]) {
                                        input = input.replace(`:${match[1]}:`, "");
                                        input = cleanInput(input);
                                        if(input[input.length - 1] === "|")
                                            input = input.slice(0, -1);
                                    }
                                }
                                if(keywordsSelected){
                                    if(selectedKeywords.length > 0){
                                        setNoKeywordsSelected("");
                                        if(input.includes("|")){
                                            const match = searchInput.match(/\*(.*?)\*/);
                                            if (match && match[1]) {
                                                input = input.replace(`*${match[1]}*`, "");
                                                input = input.replace(/\s+/g, ' ').trim();
                                                if(input[input.length - 1] === "|")
                                                    input = input.slice(0, -1);
                                            }
                                            if(input.includes("|"))
                                                input += " *" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                            else
                                                input += "|*" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                        }
                                        else{
                                            input += "|*" + selectedKeywords?.map(k => k.Value).join(";")+"*";
                                        }
                                    }
                                    else{
                                        setNoKeywordsSelected("No keywords selected!");
                                        noOptionSelected = true;
                                    }
                                }
                                else{
                                    const match = input.match(/\*(.*?)\*/);
                                    if (match && match[1]) {
                                        input = input.replace(`\*${match[1]}\*`, "");
                                        input = cleanInput(input);
                                        if(input[input.length - 1] === "|")
                                            input = input.slice(0, -1);
                                    }
                                }
                                if(!noOptionSelected) {
                                    dispatch(clearSearchResults());
                                    // setMaxResultCount(maxResultCountRedux);
                                    setIsFiltering(true);
                                    setLoadResults(true);
                                    dispatch(updateQuickSearchFilter({
                                        ...quickSearchFilter,
                                        SearchCriterias: filterCriterias,
                                        SearchCategories: localCategories
                                    }));
                                    historyPush(
                                        history,
                                        `/searchResults/${(input===null || input==="") ? "[all]" : input}/${randomID()}`
                                    );
                                }
                            }}
                            sx={{ 
                                textTransform: "none",
                                minWidth: 80
                            }}
                        >
                            {t("common.Filter")}
                        </Button>
                    </Box>
                </Paper>
            </Collapse>

            <Box sx={{ width: "100%" }}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <Tabs
                        value={value}
                        onChange={handleChangeCurrentTab}
                        aria-label="basic tabs example"
                        variant="fullWidth"
                        centered
                    >
                        {quickSearchFilter?.SearchCategories?.map(
                            (item, index) => {
                                let hasFetched =
                                    CORRESPONDANCE_STATES[item.label];
                                let resultsNumber = hasFetched?.length;
                                let isNotChecked =
                                    !quickSearchFilter.SearchCategories[index]
                                        .checked;

                                // Show progress only when this category is explicitly in loading state (null)
                                let showProgress = (hasFetched === null) && !isNotChecked;

                                return (
                                    <Tab
                                        disabled={isNotChecked}
                                        key={index}
                                        iconPosition="end"
                                        label={
                                            <Badge
                                                anchorOrigin={{
                                                    vertical: "top",
                                                    horizontal: "right",
                                                }}
                                                sx={{
                                                    right: "-12px",
                                                    top: "4px",
                                                }}
                                                showZero={true}
                                                badgeContent={resultsNumber}
                                                color={"secondary"}
                                            >
                                                <Box
                                                    sx={{
                                                        marginTop: 0.5,
                                                        marginRight: 1,
                                                    }}
                                                >
                                                    {t(
                                                        `grid.title.${item.label}`
                                                    )}
                                                </Box>
                                            </Badge>
                                        }
                                        icon={
                                            <Box>
                                                {showProgress && (
                                                    <CircularProgress
                                                        sx={{
                                                            p: 0,
                                                            m: 0,
                                                            position:
                                                                "absolute",
                                                            top: 24,
                                                            right: 0,
                                                        }}
                                                        color="secondary"
                                                        size={24}
                                                        thickness={2}
                                                    />
                                                )}
                                            </Box>
                                        }
                                    />
                                );
                            }
                        )}
                    </Tabs>
                </Box>
                <Grid container>
                    <TabPanel value={value} index={0}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                            <TextField
                                variant="standard"
                                placeholder={t("common.Search")}
                                value={entitiesSearch}
                                onChange={e => setEntitiesSearch(e.target.value)}
                                sx={{
                                    maxWidth: "400px",
                                    fontSize: "16px",
                                }}
                                InputProps={{
                                    disableUnderline: false,
                                    style: {
                                        background: "transparent",
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <DataGridPro
                                autoHeight
                                rows={filteredEntitiesResults}
                                columns={entitiesColumns}
                                getRowId={row => row.ObjectID}
                                disableColumnMenu={true}
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 25, 50]}
                                onPageSizeChange={setPageSize}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                sortModel={entitiesSortModel}
                                onSortModelChange={setEntitiesSortModel}
                                loading={entitiesResults === null}
                            />
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                            <TextField
                                variant="standard"
                                placeholder={t("common.Search")}
                                value={documentsSearch}
                                onChange={e => setDocumentsSearch(e.target.value)}
                                sx={{
                                    maxWidth: "400px",
                                    fontSize: "16px",
                                }}
                                InputProps={{
                                    disableUnderline: false,
                                    style: {
                                        background: "transparent",
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <DataGridPro
                                autoHeight
                                rows={filteredDocumentsResults}
                                columns={documentsColumns}
                                getRowId={row => row.ObjectID}
                                disableColumnMenu={true}
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 25, 50]}
                                onPageSizeChange={setPageSize}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                sortModel={documentsSortModel}
                                onSortModelChange={setDocumentsSortModel}
                                loading={documentsResults === null}
                                getDetailPanelContent={({ row }) => <DocumentDetailPanel row={row} />}
                                getDetailPanelHeight={() => "auto"}
                                components={{
                                    DetailPanelExpandIcon: KeyboardArrowRightIcon,
                                    DetailPanelCollapseIcon: KeyboardArrowDownIcon,
                                }}
                            />
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={2}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                            <TextField
                                variant="standard"
                                placeholder={t("common.Search")}
                                value={stationsSearch}
                                onChange={e => setStationsSearch(e.target.value)}
                                sx={{
                                    maxWidth: "400px",
                                    fontSize: "16px",
                                }}
                                InputProps={{
                                    disableUnderline: false,
                                    style: {
                                        background: "transparent",
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <DataGridPro
                                autoHeight
                                rows={filteredStationsResults}
                                columns={stationsColumns}
                                getRowId={row => row.ObjectID}
                                disableColumnMenu={true}
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 25, 50]}
                                onPageSizeChange={setPageSize}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                sortModel={stationsSortModel}
                                onSortModelChange={setStationsSortModel}
                                loading={stationsResults === null}
                            />
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={3}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                            <TextField
                                variant="standard"
                                placeholder={t("common.Search")}
                                value={zonesSearch}
                                onChange={e => setZonesSearch(e.target.value)}
                                sx={{
                                    maxWidth: "400px",
                                    fontSize: "16px",
                                }}
                                InputProps={{
                                    disableUnderline: false,
                                    style: {
                                        background: "transparent",
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <DataGridPro
                                autoHeight
                                rows={filteredZonesResults}
                                columns={zonesColumns}
                                getRowId={row => row.ObjectID}
                                disableColumnMenu={true}
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 25, 50]}
                                onPageSizeChange={setPageSize}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                sortModel={zonesSortModel}
                                onSortModelChange={setZonesSortModel}
                                loading={zonesResults === null}
                            />
                        </Box>
                    </TabPanel>
                    <TabPanel value={value} index={4}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
                            <TextField
                                variant="standard"
                                placeholder={t("common.Search")}
                                value={samplingsSearch}
                                onChange={e => setSamplingsSearch(e.target.value)}
                                sx={{
                                    maxWidth: "400px",
                                    fontSize: "16px",
                                }}
                                InputProps={{
                                    disableUnderline: false,
                                    style: {
                                        background: "transparent",
                                    }
                                }}
                            />
                        </Box>
                        <Box sx={{ width: "100%" }}>
                            <DataGridPro
                                autoHeight
                                rows={filteredSamplingsResults}
                                columns={samplingsColumns}
                                getRowId={row => row.ObjectID}
                                disableColumnMenu={true}
                                pageSize={pageSize}
                                rowsPerPageOptions={[10, 25, 50]}
                                onPageSizeChange={setPageSize}
                                pagination
                                sortingOrder={['asc', 'desc']}
                                sortModel={samplingsSortModel}
                                onSortModelChange={setSamplingsSortModel}
                                loading={samplingsResults === null}
                            />
                        </Box>
                    </TabPanel>
                </Grid>
            </Box>
        </Paper>
    );
};

export default QuickSearchResultsTabs;
